module.exports = __webpack_public_path__ + "img/arrow-back.c6ae3ff0.svg";